import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import Button from '../../elements/Button';
import workspaces from '../../workspaces';
const styles = {
    container: {
        display: 'flex',
    },
    item: {
        flex: '1',
        textAlign: 'left',
        fontSize: '11px',
        padding: '5px',
    },
    newContainer: {
        backgroundColor: '#f6f6f6',
        display: 'flex',
        padding: '0.3em',
    },
    input: {
        padding: '0.5em 0.8em',
        fontSize: '12px',
        color: 'black',
        outline: 'none',
        backgroundColor: 'transparent',
    },
};
function WorkspaceItem({ item, onSave, onDelete }) {
    const [name, setName] = useState('');
    // Add new workspace
    function addHandler(e) {
        e.stopPropagation();
        setName('');
        onSave(name);
    }
    // bubble onDelete
    function deleteHandler(e) {
        e.stopPropagation();
        onDelete(item.key);
    }
    function onTextChange(e) {
        setName(e.target.value);
    }
    return (_jsx("div", { children: item.key === 'new' ? (_jsxs("div", { style: styles.newContainer, children: [_jsx("input", { style: styles.input, value: name, placeholder: "Custom workspace", onClick: (e) => e.stopPropagation(), onChange: onTextChange }), _jsx(Button.Done, { onClick: addHandler, disabled: !name, style: { fontSize: '11px' }, children: "Save" })] })) : (_jsxs("div", { style: styles.container, children: [_jsx("span", { style: styles.item, children: item.label }), !workspaces[item.key] && (_jsx(Button.Danger, { onClick: deleteHandler, size: "xSmall", fill: "clear", children: _jsx(FaTimes, {}) }))] })) }));
}
export default WorkspaceItem;
